import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
import { MerchantAccount } from "../models";
import { FlexContainer, SingleSelect } from "@mindmemobile/mm-shared-global";

type Props = {
  merchantAccounts: MerchantAccount[];
  selectedMerchantAccount?: MerchantAccount;
  onChange(merchantAccount: MerchantAccount): void;
  showError: boolean;
  className?: string;
};

export const MerchantAccountsWrapper = styled.span`
  .options-menu {
    /* padding: 10px 0px; */
    /* max-height:85px; */
    .input-wrapper .searchable-dropdown-input {
      padding: 0px 0px 0px 10px !important;
    }
    .input-wrapper + div {
      max-height: 85px;
    }
  }

  .merchant-dpdn-options {
    align-items: center;
    gap: 10px;
    padding: 2px 10px;
    &:hover {
      background-color: #f8f8f8;
    }
  }
  .dpdn-with-icons {
    width: 415px;
    .header {
      width: 415px;
      max-width: unset;
    }
    .options-menu {
      width: 415px;
    }
  }
`;
const MerchantAccountsDropDown: React.FC<Props> = ({
  merchantAccounts,
  selectedMerchantAccount,
  onChange,
  showError,
  className = "",
}) => {
  return (
    <MerchantAccountsWrapper>
      <SingleSelect
        selectedKey={selectedMerchantAccount?.name || ""}
        nameKeys={["name"]}
        valueKeys={["name"]}
        options={[merchantAccounts]}
        customHeader={
          <FlexContainer spacing={10} alignItems="center">
            {!selectedMerchantAccount ||
            selectedMerchantAccount?.name === "" ? (
              <span>Select Merchant Account</span>
            ) : (
              <span>{selectedMerchantAccount?.name}</span>
            )}
          </FlexContainer>
        }
        customOption={(option: MerchantAccount) => (
          <FlexContainer
            key={option.applicationId}
            className="merchant-dpdn-options"
          >
            <span>{option.name}</span>
          </FlexContainer>
        )}
        onChange={(option) => onChange(option)}
        className={`dpdn-with-icons ${className}`}
        searchable={true}
        hasError={showError}
        searchPlaceholder=" Search..."
      />
    </MerchantAccountsWrapper>
  );
};

export default observer(MerchantAccountsDropDown);
